<script setup lang="ts">
import { computed } from 'vue'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  errorMessage: String,
})

const modelValue = defineModel<string | null | undefined>()
const content = computed({
  get: () => modelValue.value ?? '',
  set: (v: string) => { modelValue.value = v ?? '' },
})
</script>

<template>
  <div class="form-control w-full">
    <label v-if="label" class="label">
      <span class="label-text font-semibold"> {{ label }} <span v-if="required" class="text-red-500">*</span> </span>
    </label>
    <div :class="{ 'opacity-50 pointer-events-none': disabled, 'border border-red-500 rounded': errorMessage }">
      <QuillEditor
        :name="name"
        v-model:content="content"
        :placeholder="placeholder"
        content-type="html"
        theme="snow"
        class="bg-base-100"
      />
    </div>
    <span v-if="errorMessage" class="text-red-500 text-sm mt-1 ml-1">{{ errorMessage }}</span>
  </div>
</template>

<style>
/* Optionnel: Ajuster la hauteur de l'éditeur si nécessaire */
.ql-editor {
  min-height: 150px;
}
</style>
